import React, { useState, useEffect, useRef } from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Grid, 
  Switch, 
  FormControlLabel, 
  Button, 
  Paper, 
  Divider, 
  Avatar, 
  CircularProgress,
  Chip,
  Collapse,
  IconButton,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Snackbar,
  Alert,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Slider,
  Tabs,
  Tab,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';
import { 
  Refresh as RefreshIcon,
  WbSunny as SunnyIcon, 
  Nightlight as NightIcon,
  WbTwilight as EveningIcon,
  AutoAwesome as AutoAwesomeIcon,
  Settings as SettingsIcon,
  Timer as TimerIcon,
  Save as SaveIcon,
  Favorite as FavoriteIcon,
  FormatListBulleted as ListIcon,
  CalendarToday as CalendarIcon,
  Close as CloseIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Check as CheckIcon,
  SelfImprovement as MeditationIcon,
  WaterDrop as WaterIcon,
  Celebration as CelebrationIcon,
  EmojiEvents as AchievementIcon,
  InsertEmoticon as MoodIcon,
  MusicNote as MusicNoteIcon,
  CheckCircle as CheckCircleIcon,
  Spa as SpaIcon,
  Extension as PuzzleIcon,
  Psychology as BrainIcon,
  Casino as DiceIcon,
  EmojiObjects as BulbIcon,
  Colorize as ColorPickerIcon,
  Shuffle as ShuffleIcon,
  VideogameAsset as GameIcon
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';

const MemberReset = () => {
  const { user } = useAuth();
  const [dashboardSettings, setDashboardSettings] = useState({
    showWeatherWidget: true,
    showWellnessReminders: true,
    showPomodoroTimer: true,
    showActivityHeatmap: true
  });
  const [isCustomizing, setIsCustomizing] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [sessionTime, setSessionTime] = useState(0);
  const [welcomeAnimation, setWelcomeAnimation] = useState(true);
  const [streak, setStreak] = useState(0);
  const [pomodoroState, setPomodoroState] = useState({
    isRunning: false,
    isBreak: false,
    timeLeft: 25 * 60,
    cycles: 0
  });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [wellnessReminder, setWellnessReminder] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [triviaHistory, setTriviaHistory] = useState(() => {
    const saved = localStorage.getItem('triviaHistory');
    return saved ? JSON.parse(saved) : [];
  });
  const [gratitudeItems, setGratitudeItems] = useState(() => {
    const saved = localStorage.getItem('gratitudeItems');
    return saved ? JSON.parse(saved) : [];
  });
  const [newGratitude, setNewGratitude] = useState('');
  const [quickTasks, setQuickTasks] = useState(() => {
    const saved = localStorage.getItem('quickTasks');
    return saved ? JSON.parse(saved) : [];
  });
  const [newTask, setNewTask] = useState('');
  const [waterIntake, setWaterIntake] = useState(() => {
    const saved = localStorage.getItem('waterIntake');
    return saved ? parseInt(saved) : 0;
  });
  const [isBreathing, setIsBreathing] = useState(false);
  const [breathingPhase, setBreathingPhase] = useState('inhale');
  const [breathingCount, setBreathingCount] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const [moodTracker, setMoodTracker] = useState(() => {
    const today = new Date().toISOString().split('T')[0];
    const saved = localStorage.getItem('moodTracker');
    const parsed = saved ? JSON.parse(saved) : {};
    return parsed[today] || 3; // Default to neutral (3 on a 1-5 scale)
  });
  const confettiCanvasRef = useRef(null);
  const [activityLog, setActivityLog] = useState(() => {
    const saved = localStorage.getItem('activityLog');
    return saved ? JSON.parse(saved) : [];
  });
  const [activityDialogOpen, setActivityDialogOpen] = useState(false);
  const [activityDetails, setActivityDetails] = useState([]);
  
  // Game states
  const [selectedGame, setSelectedGame] = useState('');
  const [showPuzzleDialog, setShowPuzzleDialog] = useState(false);
  const [triviaDialog, setTriviaDialog] = useState(false);
  const [showColorGame, setShowColorGame] = useState(false);
  const [triviaQuestion, setTriviaQuestion] = useState({ loading: false, text: '', options: [] });
  const [triviaAnswer, setTriviaAnswer] = useState('');
  const [triviaResult, setTriviaResult] = useState(null);
  const [memoryCards, setMemoryCards] = useState([]);
  const [flippedIndexes, setFlippedIndexes] = useState([]);
  const [solvedPairs, setSolvedPairs] = useState([]);
  const [shuffling, setShuffling] = useState(false);
  const [colorTarget, setColorTarget] = useState('rgb(0, 0, 0)');
  const [colorValues, setColorValues] = useState({ r: 128, g: 128, b: 128 });
  const [colorCurrent, setColorCurrent] = useState('rgb(128, 128, 128)');
  const [colorScore, setColorScore] = useState(0);

  useEffect(() => {
    const savedSettings = localStorage.getItem('dashboardSettings');
    if (savedSettings) {
      setDashboardSettings(JSON.parse(savedSettings));
    }
    
    const savedStreak = localStorage.getItem('wellnessStreak');
    if (savedStreak) {
      setStreak(parseInt(savedStreak));
    }
    
    const timer = setTimeout(() => {
      setWelcomeAnimation(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setSessionTime(prev => prev + 1);
    }, 60000);
    
    return () => clearInterval(timer);
  }, []);
  
  useEffect(() => {
    if (!pomodoroState.isRunning) return;
    
    const timer = setInterval(() => {
      setPomodoroState(prev => {
        if (prev.timeLeft <= 0) {
          const isBreak = !prev.isBreak;
          const cycles = isBreak ? prev.cycles : prev.cycles + 1;
          const timeLeft = isBreak ? 5 * 60 : 25 * 60;
          
          const message = isBreak ? "Time for a break!" : "Back to work!";
          setSnackbarMessage(message);
          setSnackbarSeverity(isBreak ? 'info' : 'success');
          setShowSnackbar(true);
          
          return { ...prev, isBreak, timeLeft, cycles };
        }
        return { ...prev, timeLeft: prev.timeLeft - 1 };
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [pomodoroState.isRunning]);

  useEffect(() => {
    setWellnessReminder(generateWellnessReminder());
    
    const reminderTimer = setInterval(() => {
      setWellnessReminder(generateWellnessReminder());
    }, 5 * 60 * 1000);
    
    return () => clearInterval(reminderTimer);
  }, []);
  
  useEffect(() => {
    localStorage.setItem('gratitudeItems', JSON.stringify(gratitudeItems));
  }, [gratitudeItems]);
  
  useEffect(() => {
    localStorage.setItem('quickTasks', JSON.stringify(quickTasks));
  }, [quickTasks]);
  
  useEffect(() => {
    localStorage.setItem('waterIntake', waterIntake.toString());
  }, [waterIntake]);
  
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const saved = localStorage.getItem('moodTracker');
    const moodData = saved ? JSON.parse(saved) : {};
    
    if (moodData[today] !== moodTracker) {
      logActivity('mood_tracked', { value: moodTracker, label: getMoodText(moodTracker) });
    }
    
    moodData[today] = moodTracker;
    localStorage.setItem('moodTracker', JSON.stringify(moodData));
  }, [moodTracker]);
  
  useEffect(() => {
    if (!isBreathing) return;
    
    const breathingCycle = async () => {
      setBreathingPhase('inhale');
      await new Promise(resolve => setTimeout(resolve, 4000));
      
      setBreathingPhase('hold');
      await new Promise(resolve => setTimeout(resolve, 7000));
      
      setBreathingPhase('exhale');
      await new Promise(resolve => setTimeout(resolve, 8000));
      
      setBreathingCount(prev => prev + 1);
    };
    
    const interval = setInterval(breathingCycle, 19000);
    breathingCycle();
    
    return () => clearInterval(interval);
  }, [isBreathing]);
  
  useEffect(() => {
    if (breathingCount > 0 && isBreathing) {
      logActivity('breathing_cycle_completed', { totalCycles: breathingCount });
    }
  }, [breathingCount]);
  
  useEffect(() => {
    if (!showConfetti) return;
    
    const canvas = confettiCanvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const particles = [];
    const particleCount = 100;
    
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: canvas.width / 2,
        y: canvas.height / 2,
        size: Math.random() * 10 + 5,
        color: `hsl(${Math.random() * 360}, 100%, 50%)`,
        speedX: Math.random() * 12 - 6,
        speedY: Math.random() * -15 - 5,
        gravity: 0.2,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 10 - 5
      });
    }
    
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      let allSettled = true;
      
      particles.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;
        p.speedY += p.gravity;
        p.rotation += p.rotationSpeed;
        
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation * Math.PI / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size);
        ctx.restore();
        
        if (p.y < canvas.height) {
          allSettled = false;
        }
      });
      
      if (!allSettled) {
        requestAnimationFrame(animate);
      } else {
        setShowConfetti(false);
      }
    };
    
    animate();
    
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [showConfetti]);

  useEffect(() => {
    localStorage.setItem('activityLog', JSON.stringify(activityLog));
  }, [activityLog]);

  useEffect(() => {
    logActivity('session_started', { user: user?.firstName || 'Member' });
    
    return () => {
      logActivity('session_ended');
    };
  }, []);

  const generateWellnessReminder = () => {
    const hour = new Date().getHours();
    const reminders = [
      "Remember to stay hydrated!",
      "Take a moment to stretch.",
      "Stand up and walk around for a few minutes.",
      "Practice deep breathing for 30 seconds.",
      "Rest your eyes by looking away from the screen."
    ];
    
    if (sessionTime > 60) {
      return "You've been online for over an hour. Take a short break!";
    }
    
    if (hour < 12) {
      return "Morning reminder: Set your intentions for the day.";
    }
    
    if (hour >= 22) {
      return "It's getting late. Consider wrapping up soon for better sleep.";
    }
    
    return reminders[Math.floor(Math.random() * reminders.length)];
  };

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  const getTimeIcon = () => {
    const hour = currentTime.getHours();
    if (hour < 6 || hour >= 20) return <NightIcon />;
    if (hour < 12) return <SunnyIcon />;
    if (hour < 18) return <SunnyIcon />;
    return <EveningIcon />;
  };

  const saveSettings = () => {
    localStorage.setItem('dashboardSettings', JSON.stringify(dashboardSettings));
    setIsCustomizing(false);
    setSnackbarMessage("Dashboard preferences saved!");
    setSnackbarSeverity("success");
    setShowSnackbar(true);
  };

  const logActivity = (type, details = {}) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const formattedToday = `${year}-${month}-${day}`;
    
    const activity = {
      id: Date.now().toString(),
      type,
      details,
      date: formattedToday,
      time: today.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    
    setActivityLog(prev => [activity, ...prev]);
    
    if (activityLog.length > 500) {
      setActivityLog(prev => prev.slice(0, 500));
    }
  };

  const incrementStreak = () => {
    const newStreak = streak + 1;
    setStreak(newStreak);
    localStorage.setItem('wellnessStreak', newStreak.toString());
    setSnackbarMessage(`Wellness streak increased to ${newStreak}! 🎉`);
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    logActivity('wellness_completed', { streak: newStreak });
  };

  const togglePomodoro = () => {
    setPomodoroState(prev => ({ ...prev, isRunning: !prev.isRunning }));
  };

  const resetPomodoro = () => {
    setPomodoroState({
      isRunning: false,
      isBreak: false,
      timeLeft: 25 * 60,
      cycles: 0
    });
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  const addGratitude = () => {
    if (!newGratitude.trim()) return;
    
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const formattedToday = `${year}-${month}-${day}`;
    
    const newItem = { 
      id: Date.now().toString(), 
      text: newGratitude,
      date: formattedToday
    };
    
    setGratitudeItems([...gratitudeItems, newItem]);
    setNewGratitude('');
    setSnackbarMessage("Gratitude added! Positive vibes sent your way ✨");
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    logActivity('gratitude_added', { text: newGratitude.substring(0, 20) + (newGratitude.length > 20 ? '...' : '') });
  };

  const removeGratitude = (id) => {
    setGratitudeItems(gratitudeItems.filter(item => item.id !== id));
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return '';
    
    const [year, month, day] = dateString.split('-');
    return new Date(+year, +month - 1, +day).toLocaleDateString();
  };

  const addTask = () => {
    if (!newTask.trim()) return;
    
    const task = { 
      id: Date.now().toString(), 
      text: newTask,
      completed: false 
    };
    
    setQuickTasks([...quickTasks, task]);
    setNewTask('');
    logActivity('task_added', { text: newTask.substring(0, 20) + (newTask.length > 20 ? '...' : '') });
  };

  const toggleTask = (id) => {
    const updatedTasks = quickTasks.map(task => 
      task.id === id ? { ...task, completed: !task.completed } : task
    );
    
    const taskBeingToggled = quickTasks.find(task => task.id === id);
    const isCompleting = !taskBeingToggled.completed;
    
    if (isCompleting) {
      setSnackbarMessage("Task completed! You're making progress! 🚀");
      setSnackbarSeverity("success");
      setShowSnackbar(true);
      logActivity('task_completed', { text: taskBeingToggled.text.substring(0, 20) + (taskBeingToggled.text.length > 20 ? '...' : '') });
    }
    
    setQuickTasks(updatedTasks);
    
    const allCompleted = updatedTasks.every(task => task.completed);
    if (allCompleted && updatedTasks.length > 0) {
      setShowConfetti(true);
      logActivity('all_tasks_completed', { count: updatedTasks.length });
    }
  };

  const removeTask = (id) => {
    setQuickTasks(quickTasks.filter(task => task.id !== id));
  };

  const incrementWater = () => {
    const newCount = waterIntake + 1;
    setWaterIntake(newCount);
    setSnackbarMessage("Water intake recorded! Stay hydrated! 💧");
    setSnackbarSeverity("info");
    setShowSnackbar(true);
    logActivity('water_added', { count: newCount });
  };

  const resetWater = () => {
    setWaterIntake(0);
  };

  const toggleBreathing = () => {
    const newState = !isBreathing;
    setIsBreathing(newState);
    setBreathingCount(0);
    
    if (newState) {
      logActivity('breathing_started');
    } else if (breathingCount > 0) {
      logActivity('breathing_stopped', { cycles: breathingCount });
    }
  };

  const getBreathingText = () => {
    switch (breathingPhase) {
      case 'inhale': return 'Inhale...';
      case 'hold': return 'Hold...';
      case 'exhale': return 'Exhale...';
      default: return '';
    }
  };

  const getMoodColor = (value) => {
    switch(value) {
      case 1: return '#d32f2f';
      case 2: return '#ff9800';
      case 3: return '#ffeb3b';
      case 4: return '#4caf50';
      case 5: return '#2196f3';
      default: return '#9e9e9e';
    }
  };

  const getMoodText = (value) => {
    switch(value) {
      case 1: return 'Very Low';
      case 2: return 'Low';
      case 3: return 'Neutral';
      case 4: return 'Good';
      case 5: return 'Excellent';
      default: return '';
    }
  };

  const resetDaily = () => {
    resetWater();
    setQuickTasks(quickTasks.filter(task => task.completed !== true));
    setSnackbarMessage("Daily metrics reset for a fresh start!");
    setSnackbarSeverity("info");
    setShowSnackbar(true);
  };

  const completeWellness = () => {
    incrementStreak();
    incrementWater();
    setShowConfetti(true);
    setSnackbarMessage("Wellness activities completed! Great job taking care of yourself! 🎉");
    setSnackbarSeverity("success");
    setShowSnackbar(true);
    logActivity('wellness_completed', { type: 'all_activities' });
  };

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleCardClick = (index) => {
    if (flippedIndexes.length >= 2 || 
        memoryCards[index].flipped || 
        solvedPairs.includes(memoryCards[index].content)) {
      return;
    }
    
    const newCards = [...memoryCards];
    newCards[index].flipped = true;
    setMemoryCards(newCards);
    
    const newFlipped = [...flippedIndexes, index];
    setFlippedIndexes(newFlipped);
    
    if (newFlipped.length === 2) {
      const [first, second] = newFlipped;
      
      if (newCards[first].content === newCards[second].content) {
        setSolvedPairs([...solvedPairs, newCards[first].content]);
        setFlippedIndexes([]);
        
        if (solvedPairs.length + 1 === memoryCards.length / 2) {
          setSnackbarMessage("Congratulations! You've completed the memory game! 🎉");
          setSnackbarSeverity("success");
          setShowSnackbar(true);
          setShowConfetti(true);
          logActivity('game_completed', { type: 'memory_match', pairs: memoryCards.length / 2 });
        }
      } else {
        setTimeout(() => {
          newCards[first].flipped = false;
          newCards[second].flipped = false;
          setMemoryCards(newCards);
          setFlippedIndexes([]);
        }, 1000);
      }
    }
  };

  const resetMemoryGame = () => {
    setShuffling(true);
    
    const emojis = ['🎮', '🎯', '🎪', '🎨', '🎭', '🎰', '🎲', '🎳'];
    const cardPairs = [...emojis, ...emojis];
    
    setTimeout(() => {
      setMemoryCards(shuffleArray(cardPairs.map((emoji, index) => ({
        id: index,
        content: emoji,
        flipped: false,
        solved: false
      }))));
      setFlippedIndexes([]);
      setSolvedPairs([]);
      setShuffling(false);
      logActivity('game_started', { type: 'memory_match' });
    }, 500);
  };

  const generateNewColorTarget = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    
    setColorTarget(`rgb(${r}, ${g}, ${b})`);
    setColorValues({ r: 128, g: 128, b: 128 });
    setColorCurrent(`rgb(128, 128, 128)`);
  };

  const handleColorChange = (channel, value) => {
    const newValues = { ...colorValues, [channel]: value };
    setColorValues(newValues);
    setColorCurrent(`rgb(${newValues.r}, ${newValues.g}, ${newValues.b})`);
  };

  const checkColorMatch = () => {
    const targetStyle = getComputedStyle(document.documentElement).getPropertyValue(colorTarget);
    
    const distance = Math.sqrt(
      Math.pow(parseInt(colorValues.r) - targetStyle.r, 2) +
      Math.pow(parseInt(colorValues.g) - targetStyle.g, 2) +
      Math.pow(parseInt(colorValues.b) - targetStyle.b, 2)
    );
    
    const maxDistance = Math.sqrt(3 * Math.pow(255, 2));
    const matchScore = Math.round(100 - (distance / maxDistance * 100));
    
    setColorScore(matchScore);
    
    if (matchScore > 90) {
      setSnackbarMessage(`Perfect match! Score: ${matchScore}%`);
      setSnackbarSeverity("success");
      setShowConfetti(true);
    } else if (matchScore > 80) {
      setSnackbarMessage(`Great job! Score: ${matchScore}%`);
      setSnackbarSeverity("success");
    } else if (matchScore > 70) {
      setSnackbarMessage(`Good try! Score: ${matchScore}%`);
      setSnackbarSeverity("info");
    } else {
      setSnackbarMessage(`Keep trying! Score: ${matchScore}%`);
      setSnackbarSeverity("info");
    }
    
    setShowSnackbar(true);
    
    setTimeout(() => {
      generateNewColorTarget();
    }, 2000);
  };

  const loadTriviaQuestion = async () => {
    try {
      setTriviaQuestion({
        loading: true,
        text: "Loading question...",
        options: []
      });
      
      const sampleQuestions = [
        {
          question: "What is the recommended daily water intake for adults?",
          options: ["1-2 glasses", "3-4 glasses", "8 glasses", "15 glasses"],
          correct: "8 glasses",
          category: "Health"
        },
        {
          question: "Which of these activities is best for stress reduction?",
          options: ["Scrolling social media", "Deep breathing", "Caffeine consumption", "Multitasking"],
          correct: "Deep breathing",
          category: "Wellness"
        },
        {
          question: "How many minutes of physical activity are recommended daily?",
          options: ["10 minutes", "30 minutes", "1 hour", "2 hours"],
          correct: "30 minutes",
          category: "Health"
        },
        {
          question: "Which is a good practice for improved sleep?",
          options: ["Using screens before bed", "Irregular sleep schedule", "Consistent bedtime routine", "Caffeine before bed"],
          correct: "Consistent bedtime routine",
          category: "Sleep"
        },
        {
          question: "What is the Pomodoro technique used for?",
          options: ["Cooking", "Time management", "Meditation", "Exercise"],
          correct: "Time management",
          category: "Productivity"
        }
      ];
      
      let availableQuestions = sampleQuestions.filter(q => 
        !triviaHistory.some(h => h.question === q.question)
      );
      
      if (availableQuestions.length === 0) {
        availableQuestions = sampleQuestions;
        setTriviaHistory([]);
      }
      
      const randomIndex = Math.floor(Math.random() * availableQuestions.length);
      const question = availableQuestions[randomIndex];
      
      await new Promise(resolve => setTimeout(resolve, 800));
      
      setTriviaQuestion({
        loading: false,
        text: question.question,
        options: question.options,
        correct: question.correct,
        category: question.category
      });
    } catch (error) {
      console.error("Error loading trivia:", error);
      setTriviaQuestion({
        loading: false,
        text: "Error loading question. Please try again.",
        options: []
      });
    }
  };

  const submitTriviaAnswer = () => {
    if (!triviaQuestion || triviaQuestion.loading) return;
    
    const isCorrect = triviaAnswer === triviaQuestion.correct;
    setTriviaResult({
      correct: isCorrect,
      message: isCorrect 
        ? "Correct! Well done!" 
        : `Incorrect. The correct answer is: ${triviaQuestion.correct}`
    });
    
    setTriviaHistory([
      ...triviaHistory, 
      { 
        question: triviaQuestion.text, 
        answer: triviaAnswer, 
        correct: isCorrect,
        category: triviaQuestion.category
      }
    ]);
    
    logActivity('trivia_answered', { 
      category: triviaQuestion.category,
      correct: isCorrect,
      question: triviaQuestion.text.substring(0, 30) + (triviaQuestion.text.length > 30 ? '...' : '')
    });
    
    if (isCorrect) {
      setShowConfetti(true);
    }
  };

  const nextTriviaQuestion = () => {
    setTriviaAnswer('');
    setTriviaResult(null);
    loadTriviaQuestion();
  };

  const getWeatherData = () => {
    const tempC = 28;
    const tempF = Math.round(tempC * 9/5 + 32);
    return { tempC, tempF };
  };

  const weather = getWeatherData();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const generateHeatmapData = () => {
    const today = new Date();
    const last30Days = Array.from({ length: 30 }, (_, i) => {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    });
    
    const activityCountByDay = {};
    last30Days.forEach(date => {
      activityCountByDay[date] = { 
        count: 0,
        activities: []
      };
    });
    
    activityLog.forEach(activity => {
      if (activityCountByDay.hasOwnProperty(activity.date)) {
        activityCountByDay[activity.date].count++;
        activityCountByDay[activity.date].activities.push({
          type: getActivityTypeLabel(activity.type),
          time: activity.time,
          details: activity.details
        });
      }
    });
    
    gratitudeItems.forEach(item => {
      if (activityCountByDay.hasOwnProperty(item.date) && 
          !activityLog.some(a => a.type === 'gratitude_added' && a.date === item.date && a.details?.text?.includes(item.text.substring(0, 10)))) {
        activityCountByDay[item.date].count++;
        activityCountByDay[item.date].activities.push({
          type: 'Added gratitude entry',
          time: '—',
          details: { text: item.text }
        });
      }
    });
    
    const data = last30Days.map(date => {
      return {
        date,
        level: Math.min(activityCountByDay[date].count, 4),
        activities: activityCountByDay[date].activities
      };
    });
    
    return data.reverse();
  };

  const getActivityTypeLabel = (type) => {
    const labels = {
      'wellness_completed': 'Completed wellness activity',
      'gratitude_added': 'Added gratitude entry',
      'task_added': 'Added task',
      'task_completed': 'Completed task',
      'all_tasks_completed': 'Completed all tasks',
      'water_added': 'Tracked water intake',
      'breathing_started': 'Started breathing exercise',
      'breathing_stopped': 'Completed breathing exercise',
      'breathing_cycle_completed': 'Completed breathing cycle',
      'mood_tracked': 'Updated mood tracking',
      'game_started': 'Started brain game',
      'game_completed': 'Completed brain game',
      'trivia_answered': 'Answered trivia question',
      'session_started': 'Started wellness session',
      'session_ended': 'Ended wellness session'
    };
    
    return labels[type] || 'Performed activity';
  };

  const heatmapData = generateHeatmapData();

  const handleViewAllActivity = () => {
    const detailedActivities = heatmapData
      .filter(day => day.level > 0)
      .map(day => ({
        date: formatDateDisplay(day.date),
        count: day.level,
        details: day.activities.length > 0 
          ? day.activities 
          : [{ type: 'No detailed activity data available', time: '--:--' }]
      }));
      
    setActivityDetails(detailedActivities);
    setActivityDialogOpen(true);
  };

  return (
    <Box sx={{ p: 3, mt: { xs: 8, md: 2 } }}>
      <Collapse in={welcomeAnimation}>
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Card sx={{ mb: 3, background: 'linear-gradient(45deg, #3f51b5, #2196f3)' }}>
            <CardContent sx={{ textAlign: 'center', color: 'white' }}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1, rotate: 360 }}
                transition={{ duration: 1.2 }}
              >
                <Avatar 
                  sx={{ 
                    width: 80, 
                    height: 80, 
                    mx: 'auto', 
                    mb: 2, 
                    bgcolor: '#fff',
                    color: '#3f51b5',
                    fontSize: '2rem',
                    fontWeight: 'bold'
                  }}
                >
                  {user?.firstName?.charAt(0) || 'M'}
                </Avatar>
              </motion.div>
              <Typography variant="h4" component="div" gutterBottom>
                Welcome back, {user?.firstName || 'Member'}!
              </Typography>
              <Typography variant="body1">
                Your dashboard is ready with the latest updates
              </Typography>
            </CardContent>
          </Card>
        </motion.div>
      </Collapse>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h5" component="div">
              <AutoAwesomeIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              Dashboard Reset
            </Typography>
            <Button 
              variant="outlined" 
              startIcon={<SettingsIcon />}
              onClick={() => setIsCustomizing(!isCustomizing)}
            >
              {isCustomizing ? 'Cancel' : 'Customize Dashboard'}
            </Button>
          </Paper>
        </Grid>

        {isCustomizing && (
          <Grid item xs={12}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Dashboard Widgets
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch 
                        checked={dashboardSettings.showWeatherWidget} 
                        onChange={() => setDashboardSettings(prev => ({
                          ...prev, 
                          showWeatherWidget: !prev.showWeatherWidget
                        }))}
                      />
                    }
                    label="Time & Weather Widget"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch 
                        checked={dashboardSettings.showWellnessReminders} 
                        onChange={() => setDashboardSettings(prev => ({
                          ...prev, 
                          showWellnessReminders: !prev.showWellnessReminders
                        }))}
                      />
                    }
                    label="Wellness Reminders"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch 
                        checked={dashboardSettings.showPomodoroTimer} 
                        onChange={() => setDashboardSettings(prev => ({
                          ...prev, 
                          showPomodoroTimer: !prev.showPomodoroTimer
                        }))}
                      />
                    }
                    label="Pomodoro Timer"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch 
                        checked={dashboardSettings.showActivityHeatmap} 
                        onChange={() => setDashboardSettings(prev => ({
                          ...prev, 
                          showActivityHeatmap: !prev.showActivityHeatmap
                        }))}
                      />
                    }
                    label="Activity Heatmap"
                  />
                </Grid>
              </Grid>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button 
                  variant="contained" 
                  startIcon={<SaveIcon />}
                  onClick={saveSettings}
                >
                  Save Preferences
                </Button>
              </Box>
            </Paper>
          </Grid>
        )}

        <Grid container item spacing={3}>
          {dashboardSettings.showWeatherWidget && (
            <Grid item xs={12} md={6}>
              <Card 
                sx={{ 
                  background: currentTime.getHours() < 12 
                    ? 'linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%)' 
                    : currentTime.getHours() < 18 
                      ? 'linear-gradient(120deg, #f6d365 0%, #fda085 100%)' 
                      : 'linear-gradient(120deg, #0c2461 0%, #1e3799 100%)',
                  color: currentTime.getHours() >= 18 ? 'white' : 'inherit',
                  height: '100%'
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h5" component="div">
                      {getTimeIcon()}
                      <span style={{ marginLeft: '8px' }}>{getGreeting()}</span>
                    </Typography>
                    <Chip 
                      label={currentTime.toLocaleDateString(undefined, { weekday: 'long' })} 
                      color="primary" 
                      variant="outlined"
                    />
                  </Box>
                  <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                    {currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </Typography>
                  <Typography variant="body1">
                    {currentTime.toLocaleDateString(undefined, { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </Typography>
                  <Box sx={{ mt: 3, display: 'flex', alignItems: 'center' }}>
                    <SunnyIcon sx={{ mr: 1 }} />
                    <Typography variant="body1">
                      {weather.tempC}°C | {weather.tempF}°F | Sunny
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {dashboardSettings.showActivityHeatmap && (
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" component="div" gutterBottom>
                    <CalendarIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Activity Heatmap
                  </Typography>
                  <Box sx={{ mt: 2, overflow: 'auto' }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {heatmapData.map((day, index) => (
                        <Box 
                          key={index}
                          sx={{ 
                            width: 20, 
                            height: 20, 
                            bgcolor: day.level === 0 
                              ? '#ebedf0' 
                              : day.level === 1 
                                ? '#c6e48b' 
                                : day.level === 2 
                                  ? '#7bc96f' 
                                  : day.level === 3 
                                    ? '#239a3b' 
                                    : '#196127',
                            borderRadius: '2px',
                            cursor: 'pointer',
                            '&:hover': {
                              transform: 'scale(1.1)',
                              boxShadow: '0 0 5px rgba(0,0,0,0.2)'
                            }
                          }}
                          title={`${formatDateDisplay(day.date)}: ${day.level} activities`}
                          onClick={() => {
                            const dayActivities = {
                              date: formatDateDisplay(day.date),
                              count: day.level,
                              details: day.activities.length > 0 
                                ? day.activities 
                                : [{ type: 'No activities on this day', time: '--:--' }]
                            };
                            setActivityDetails([dayActivities]);
                            setActivityDialogOpen(true);
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                  <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                        Less
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Box sx={{ width: 12, height: 12, bgcolor: '#ebedf0', borderRadius: '2px' }} />
                        <Box sx={{ width: 12, height: 12, bgcolor: '#c6e48b', borderRadius: '2px' }} />
                        <Box sx={{ width: 12, height: 12, bgcolor: '#7bc96f', borderRadius: '2px' }} />
                        <Box sx={{ width: 12, height: 12, bgcolor: '#239a3b', borderRadius: '2px' }} />
                        <Box sx={{ width: 12, height: 12, bgcolor: '#196127', borderRadius: '2px' }} />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                        More
                      </Typography>
                    </Box>
                    <Button 
                      size="small" 
                      onClick={handleViewAllActivity}
                      startIcon={<ListIcon />}
                    >
                      View All Activity
                    </Button>
                  </Box>
                  {activityLog.length === 0 && heatmapData.every(day => day.level === 0) && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                      No activity recorded yet. Complete wellness activities to see your progress.
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ mb: 2 }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange} 
              variant="scrollable"
              scrollButtons="auto"
              sx={{ 
                borderBottom: 1, 
                borderColor: 'divider',
                '.MuiTab-root': { minWidth: 0 }
              }}
            >
              <Tab icon={<AutoAwesomeIcon />} label="Dashboard" />
              <Tab icon={<SpaIcon />} label="Mindfulness" />
              <Tab icon={<ListIcon />} label="Quick Reset" />
              <Tab icon={<MoodIcon />} label="Mood & Health" />
              <Tab icon={<GameIcon />} label="Games & Puzzles" />
            </Tabs>
          </Paper>
        </Grid>
        
        <AnimatePresence mode="wait">
          <motion.div
            key={tabValue}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            style={{ width: '100%' }}
          >
            {tabValue === 0 && (
              <Grid container spacing={3}>
                {dashboardSettings.showWellnessReminders && (
                  <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Typography variant="h6" component="div" gutterBottom>
                          <FavoriteIcon color="error" sx={{ mr: 1, verticalAlign: 'middle' }} />
                          Wellness Reminder
                        </Typography>
                        <Box sx={{ my: 2, p: 2, bgcolor: 'rgba(0, 0, 0, 0.03)', borderRadius: 1 }}>
                          <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
                            "{wellnessReminder}"
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Your wellness streak
                            </Typography>
                            <Typography variant="h6" component="div">
                              {streak} days 🔥
                            </Typography>
                          </Box>
                          <Button 
                            variant="contained" 
                            color="success" 
                            size="small"
                            onClick={() => {
                              incrementStreak();
                              setWellnessReminder(generateWellnessReminder());
                            }}
                          >
                            Complete Today
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                {dashboardSettings.showPomodoroTimer && (
                  <Grid item xs={12} md={6}>
                    <Card>
                      <CardContent>
                        <Typography variant="h6" component="div" gutterBottom>
                          <TimerIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                          Pomodoro Timer
                        </Typography>
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          alignItems: 'center',
                          mt: 2, 
                          p: 2,
                          bgcolor: pomodoroState.isBreak ? 'rgba(76, 175, 80, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                          borderRadius: 2,
                        }}>
                          <Typography variant="subtitle1" gutterBottom>
                            {pomodoroState.isBreak ? 'Break Time' : 'Focus Time'}
                          </Typography>
                          <Box sx={{ position: 'relative', display: 'inline-flex', my: 2 }}>
                            <CircularProgress 
                              variant="determinate" 
                              value={pomodoroState.isBreak 
                                ? (1 - pomodoroState.timeLeft / (5 * 60)) * 100
                                : (1 - pomodoroState.timeLeft / (25 * 60)) * 100
                              } 
                              size={120}
                              color={pomodoroState.isBreak ? "success" : "error"}
                            />
                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <Typography variant="h4" component="div" color="text.secondary">
                                {formatTime(pomodoroState.timeLeft)}
                              </Typography>
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button 
                              variant="contained" 
                              color={pomodoroState.isRunning ? "warning" : "primary"}
                              onClick={togglePomodoro}
                            >
                              {pomodoroState.isRunning ? 'Pause' : 'Start'}
                            </Button>
                            <Button 
                              variant="outlined" 
                              onClick={resetPomodoro}
                            >
                              Reset
                            </Button>
                          </Box>
                        </Box>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">
                            Completed cycles: {pomodoroState.cycles}
                          </Typography>
                          <Chip 
                            label={pomodoroState.isBreak ? "Break Mode" : "Focus Mode"} 
                            color={pomodoroState.isBreak ? "success" : "error"} 
                            size="small" 
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
              </Grid>
            )}
            
            {tabValue === 1 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <MeditationIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        4-7-8 Breathing Exercise
                      </Typography>
                      <Box sx={{ textAlign: 'center', my: 2, position: 'relative' }}>
                        <Box
                          component={motion.div}
                          animate={{
                            scale: breathingPhase === 'inhale' ? 1.5 : 
                                  breathingPhase === 'hold' ? 1.5 : 1,
                            opacity: breathingPhase === 'exhale' ? 0.7 : 1,
                            transition: { 
                              duration: breathingPhase === 'inhale' ? 4 : 
                                      breathingPhase === 'hold' ? 7 : 8 
                            }
                          }}
                          sx={{ 
                            width: 120, 
                            height: 120, 
                            borderRadius: '50%', 
                            margin: 'auto',
                            bgcolor: isBreathing ? 'primary.main' : 'grey.300',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Typography variant="h5" color="white">
                            {isBreathing ? getBreathingText() : "Start"}
                          </Typography>
                        </Box>
                      </Box>
                      
                      <Box sx={{ textAlign: 'center', mt: 3 }}>
                        <Typography variant="body2" gutterBottom>
                          Completed cycles: {breathingCount}
                        </Typography>
                        <Button 
                          variant="contained" 
                          onClick={toggleBreathing}
                          color={isBreathing ? "error" : "primary"}
                          sx={{ mt: 1 }}
                        >
                          {isBreathing ? "Stop" : "Start Breathing"}
                        </Button>
                      </Box>
                      
                      {!isBreathing && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                          The 4-7-8 breathing technique helps reduce anxiety and stress. Inhale for 4 seconds, 
                          hold for 7 seconds, and exhale for 8 seconds.
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <FavoriteIcon sx={{ mr: 1, verticalAlign: 'middle', color: '#e91e63' }} />
                        Gratitude Journal
                      </Typography>
                      
                      <Box sx={{ display: 'flex', mt: 2, mb: 3 }}>
                        <TextField
                          fullWidth
                          size="small"
                          label="I'm grateful for..."
                          variant="outlined"
                          value={newGratitude}
                          onChange={(e) => setNewGratitude(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && addGratitude()}
                        />
                        <Button 
                          variant="contained" 
                          color="primary"
                          onClick={addGratitude}
                          sx={{ ml: 1 }}
                        >
                          <AddIcon />
                        </Button>
                      </Box>
                      
                      <List sx={{ maxHeight: 240, overflow: 'auto' }}>
                        <AnimatePresence>
                          {gratitudeItems.map((item) => (
                            <motion.div
                              key={item.id}
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: 'auto' }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                            >
                              <ListItem
                                secondaryAction={
                                  <IconButton edge="end" onClick={() => removeGratitude(item.id)}>
                                    <DeleteIcon />
                                  </IconButton>
                                }
                              >
                                <ListItemIcon>
                                  <FavoriteIcon sx={{ color: '#e91e63' }} />
                                </ListItemIcon>
                                <ListItemText 
                                  primary={item.text}
                                  secondary={formatDateDisplay(item.date)}
                                />
                              </ListItem>
                            </motion.div>
                          ))}
                        </AnimatePresence>
                      </List>
                      
                      {gratitudeItems.length === 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>
                          Start adding things you're grateful for. Practicing gratitude improves mental wellbeing.
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
            
            {tabValue === 2 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <CheckCircleIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Quick Tasks
                      </Typography>
                      
                      <Box sx={{ display: 'flex', mt: 2, mb: 3 }}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Add a quick task..."
                          variant="outlined"
                          value={newTask}
                          onChange={(e) => setNewTask(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && addTask()}
                        />
                        <Button 
                          variant="contained" 
                          color="primary"
                          onClick={addTask}
                          sx={{ ml: 1 }}
                        >
                          <AddIcon />
                        </Button>
                      </Box>
                      
                      <List sx={{ maxHeight: 240, overflow: 'auto' }}>
                        <AnimatePresence>
                          {quickTasks.map((task) => (
                            <motion.div
                              key={task.id}
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: 'auto' }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                            >
                              <ListItem
                                secondaryAction={
                                  <IconButton edge="end" onClick={() => removeTask(task.id)}>
                                    <DeleteIcon />
                                  </IconButton>
                                }
                              >
                                <ListItemIcon>
                                  <Checkbox
                                    edge="start"
                                    checked={task.completed}
                                    onChange={() => toggleTask(task.id)}
                                    color="primary"
                                  />
                                </ListItemIcon>
                                <ListItemText 
                                  primary={task.text}
                                  sx={{ 
                                    textDecoration: task.completed ? 'line-through' : 'none',
                                    color: task.completed ? 'text.secondary' : 'text.primary'
                                  }}
                                />
                              </ListItem>
                            </motion.div>
                          ))}
                        </AnimatePresence>
                      </List>
                      
                      {quickTasks.length === 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 2 }}>
                          Add simple tasks that will help you reset. Completing them will give you a sense of accomplishment.
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <WaterIcon sx={{ mr: 1, verticalAlign: 'middle', color: '#29b6f6' }} />
                        Water Intake Tracker
                      </Typography>
                      
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 3 }}>
                        <Box sx={{ position: 'relative', width: 120, height: 120 }}>
                          <CircularProgress 
                            variant="determinate" 
                            value={Math.min((waterIntake / 8) * 100, 100)} 
                            size={120}
                            thickness={4}
                            sx={{ color: '#29b6f6' }}
                          />
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography variant="h4" component="div" color="text.secondary">
                              {waterIntake}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      
                      <Typography variant="body2" align="center" gutterBottom>
                        {waterIntake} of 8 glasses
                      </Typography>
                      
                      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}>
                        <Button 
                          variant="contained" 
                          color="primary"
                          onClick={incrementWater}
                          startIcon={<WaterIcon />}
                        >
                          Add Water
                        </Button>
                        <Button 
                          variant="outlined" 
                          onClick={resetWater}
                        >
                          Reset
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <AutoAwesomeIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Quick Actions
                      </Typography>
                      
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', mt: 2 }}>
                        <Button 
                          variant="contained" 
                          color="primary"
                          startIcon={<CheckIcon />}
                          onClick={completeWellness}
                        >
                          Complete All Wellness
                        </Button>
                        <Button 
                          color="warning"
                          startIcon={<RefreshIcon />}
                          onClick={resetDaily}
                        >
                          Reset Daily Metrics
                        </Button>
                        <Button 
                          variant="outlined"
                          color="info"
                          startIcon={<MeditationIcon />}
                          onClick={() => {
                            setTabValue(1);
                            setIsBreathing(true);
                          }}
                        >
                          Quick Breathing
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
            
            {tabValue === 3 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <MoodIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Daily Mood Tracker
                      </Typography>
                      
                      <Box sx={{ px: 3, pt: 3 }}>
                        <Typography gutterBottom>
                          How are you feeling today?
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Typography sx={{ mr: 2, color: 'text.secondary' }}>Low</Typography>
                          <Slider
                            value={moodTracker}
                            onChange={(e, newValue) => setMoodTracker(newValue)}
                            step={1}
                            marks
                            min={1}
                            max={5}
                            valueLabelDisplay="off"
                            sx={{
                              '& .MuiSlider-thumb': {
                                bgcolor: getMoodColor(moodTracker),
                              },
                              '& .MuiSlider-track': {
                                bgcolor: getMoodColor(moodTracker),
                              }
                            }}
                          />
                          <Typography sx={{ ml: 2, color: 'text.secondary' }}>High</Typography>
                        </Box>
                        
                        <Box sx={{ textAlign: 'center', my: 2 }}>
                          <Chip 
                            icon={<MoodIcon />} 
                            label={getMoodText(moodTracker)} 
                            sx={{ 
                              bgcolor: getMoodColor(moodTracker),
                              color: moodTracker === 3 ? 'rgba(0,0,0,0.87)' : 'white',
                              fontWeight: 'bold'
                            }} 
                          />
                        </Box>
                      </Box>
                      
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, px: 3, textAlign: 'center' }}>
                        Tracking your mood helps identify patterns and improve mental wellness over time.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <AchievementIcon sx={{ mr: 1, verticalAlign: 'middle', color: '#ffc107' }} />
                        Wellness Achievements
                      </Typography>
                      
                      <Box sx={{ mt: 2 }}>
                        <List>
                          <ListItem>
                            <ListItemIcon>
                              {streak >= 3 ? <CheckCircleIcon color="success" /> : <AchievementIcon color="disabled" />}
                            </ListItemIcon>
                            <ListItemText 
                              primary="Wellness Streak: 3 Days" 
                              secondary={`Current streak: ${streak} days`}
                            />
                          </ListItem>
                          
                          <ListItem>
                            <ListItemIcon>
                              {waterIntake >= 8 ? <CheckCircleIcon color="success" /> : <AchievementIcon color="disabled" />}
                            </ListItemIcon>
                            <ListItemText 
                              primary="Hydration Master" 
                              secondary="Drink 8 glasses of water in a day"
                            />
                          </ListItem>
                          
                          <ListItem>
                            <ListItemIcon>
                              {breathingCount >= 3 ? <CheckCircleIcon color="success" /> : <AchievementIcon color="disabled" />}
                            </ListItemIcon>
                            <ListItemText 
                              primary="Mindful Breather" 
                              secondary="Complete 3 breathing cycles"
                            />
                          </ListItem>
                          
                          <ListItem>
                            <ListItemIcon>
                              {gratitudeItems.length >= 3 ? <CheckCircleIcon color="success" /> : <AchievementIcon color="disabled" />}
                            </ListItemIcon>
                            <ListItemText 
                              primary="Gratitude Practice" 
                              secondary="Record 3 things you're grateful for"
                            />
                          </ListItem>
                        </List>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}

            {tabValue === 4 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <BrainIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Brain Games & Puzzles
                      </Typography>
                      
                      <Typography variant="body2" sx={{ mb: 3 }}>
                        Take a mental break with these quick games designed to refresh your mind and improve focus.
                      </Typography>
                      
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Card 
                            variant="outlined" 
                            sx={{ 
                              height: '100%',
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: 3,
                                cursor: 'pointer'
                              }
                            }}
                            onClick={() => {
                              setSelectedGame('memory');
                              setShowPuzzleDialog(true);
                              resetMemoryGame();
                            }}
                          >
                            <CardContent sx={{ textAlign: 'center' }}>
                              <PuzzleIcon fontSize="large" color="primary" />
                              <Typography variant="h6" sx={{ mt: 1 }}>Memory Match</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Test your memory by matching pairs of cards
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                          <Card 
                            variant="outlined" 
                            sx={{ 
                              height: '100%',
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: 3,
                                cursor: 'pointer'
                              }
                            }}
                            onClick={() => {
                              setTriviaDialog(true);
                              loadTriviaQuestion();
                            }}
                          >
                            <CardContent sx={{ textAlign: 'center' }}>
                              <BulbIcon fontSize="large" color="primary" />
                              <Typography variant="h6" sx={{ mt: 1 }}>Wellness Trivia</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Test your knowledge with wellness questions
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                          <Card 
                            variant="outlined" 
                            sx={{ 
                              height: '100%',
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              '&:hover': {
                                transform: 'translateY(-5px)',
                                boxShadow: 3,
                                cursor: 'pointer'
                              }
                            }}
                            onClick={() => {
                              setShowColorGame(true);
                            }}
                          >
                            <CardContent sx={{ textAlign: 'center' }}>
                              <ColorPickerIcon fontSize="large" color="primary" />
                              <Typography variant="h6" sx={{ mt: 1 }}>Color Matcher</Typography>
                              <Typography variant="body2" color="text.secondary">
                                Match colors to improve focus and perception
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <AchievementIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Brain Game Stats
                      </Typography>
                      
                      {triviaHistory.length > 0 ? (
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell>Category</TableCell>
                                <TableCell>Question</TableCell>
                                <TableCell align="right">Result</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {triviaHistory.slice(-5).map((record, index) => (
                                <TableRow key={index}>
                                  <TableCell>{record.category}</TableCell>
                                  <TableCell sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {record.question}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Chip 
                                      size="small"
                                      label={record.correct ? "Correct" : "Incorrect"}
                                      color={record.correct ? "success" : "error"}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <Box sx={{ textAlign: 'center', py: 2 }}>
                          <Typography color="text.secondary">
                            Play some brain games to see your stats here!
                          </Typography>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card>
                    <CardContent>
                      <Typography variant="h6" component="div" gutterBottom>
                        <MusicNoteIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Ambient Sounds
                      </Typography>
                      
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                        Background sounds can improve focus and reduce distractions. Try different sounds to find what works best for you.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
          </motion.div>
        </AnimatePresence>
      </Grid>

      <SpeedDial
        ariaLabel="Quick actions"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
      >
        <SpeedDialAction
          icon={<RefreshIcon />}
          tooltipTitle="Refresh Dashboard"
          onClick={() => window.location.reload()}
        />
        <SpeedDialAction
          icon={<TimerIcon />}
          tooltipTitle="Start Pomodoro"
          onClick={() => setPomodoroState(prev => ({ ...prev, isRunning: true }))}
        />
        <SpeedDialAction
          icon={<FavoriteIcon />}
          tooltipTitle="Mark Wellness Complete"
          onClick={incrementStreak}
        />
        <SpeedDialAction
          icon={<SettingsIcon />}
          tooltipTitle="Dashboard Settings"
          onClick={() => setIsCustomizing(true)}
        />
      </SpeedDial>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => setShowSnackbar(false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {showConfetti && (
        <canvas
          ref={confettiCanvasRef}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999,
          }}
          width={window.innerWidth}
          height={window.innerHeight}
        />
      )}

      <Dialog
        open={activityDialogOpen}
        onClose={() => setActivityDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Activity History</Typography>
            <IconButton onClick={() => setActivityDialogOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {activityDetails.length > 0 ? (
            <TableContainer component={Paper} variant="outlined">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Activity Count</TableCell>
                    <TableCell>Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activityDetails.map((day, index) => (
                    <TableRow key={index}>
                      <TableCell>{day.date}</TableCell>
                      <TableCell>
                        <Chip 
                          label={day.count}
                          size="small"
                          color={
                            day.count >= 4 ? "success" :
                            day.count >= 2 ? "primary" :
                            "default"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <List dense>
                          {day.details.map((activity, idx) => (
                            <ListItem key={idx} disableGutters>
                              <ListItemIcon sx={{ minWidth: 36 }}>
                                <Chip 
                                  label={activity.time} 
                                  size="small" 
                                  variant="outlined"
                                  sx={{ fontSize: '0.7rem' }}
                                />
                              </ListItemIcon>
                              <ListItemText 
                                primary={activity.type}
                                secondary={activity.details?.text ? `"${activity.details.text}"` : null}
                              />
                            </ListItem>
                          ))}
                        </List>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography color="text.secondary">No activity data available</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setActivityDialogOpen(false)}>Close</Button>
          {activityLog.length > 0 && (
            <Button 
              onClick={() => {
                if (window.confirm('Are you sure you want to clear all activity history? This cannot be undone.')) {
                  setActivityLog([]);
                  setActivityDialogOpen(false);
                  setSnackbarMessage("Activity history cleared successfully");
                  setSnackbarSeverity("info");
                  setShowSnackbar(true);
                }
              }}
              color="error"
            >
              Clear History
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Memory Game Dialog */}
      <Dialog
        open={showPuzzleDialog}
        onClose={() => setShowPuzzleDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Memory Match Game</Typography>
            <IconButton onClick={() => setShowPuzzleDialog(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Match pairs of cards to test your memory. Find all pairs to complete the game.
          </Typography>
          
          {shuffling ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={1} sx={{ maxWidth: 400, margin: '0 auto' }}>
              {memoryCards.map((card, index) => (
                <Grid item xs={3} key={index}>
                  <Paper
                    sx={{
                      height: 60,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      bgcolor: card.flipped || solvedPairs.includes(card.content) 
                        ? 'white' 
                        : 'primary.main',
                      color: 'white',
                      fontSize: '1.5rem',
                      transition: 'all 0.3s',
                      transform: card.flipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                      '&:hover': {
                        bgcolor: card.flipped || solvedPairs.includes(card.content)
                          ? 'white'
                          : 'primary.dark'
                      }
                    }}
                    onClick={() => handleCardClick(index)}
                  >
                    {(card.flipped || solvedPairs.includes(card.content)) && (
                      <Typography 
                        sx={{ 
                          color: solvedPairs.includes(card.content) ? 'success.main' : 'primary.main',
                          fontSize: '1.5rem'
                        }}
                      >
                        {card.content}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
          
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Pairs found: {solvedPairs.length} / {memoryCards.length / 2}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => resetMemoryGame()}>
            Reset Game
          </Button>
          <Button onClick={() => setShowPuzzleDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Trivia Game Dialog */}
      <Dialog
        open={triviaDialog}
        onClose={() => setTriviaDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Wellness Trivia</Typography>
            <IconButton onClick={() => setTriviaDialog(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {triviaQuestion.loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : triviaResult ? (
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <Chip 
                label={triviaResult.correct ? "Correct!" : "Incorrect"} 
                color={triviaResult.correct ? "success" : "error"}
                sx={{ mb: 2 }}
              />
              <Typography variant="body1">
                {triviaResult.message}
              </Typography>
              <Button 
                variant="contained" 
                color="primary" 
                sx={{ mt: 3 }}
                onClick={nextTriviaQuestion}
              >
                Next Question
              </Button>
            </Box>
          ) : (
            <>
              <Typography variant="h6" sx={{ mb: 3 }}>
                {triviaQuestion.text}
              </Typography>
              
              <FormControl component="fieldset" sx={{ width: '100%' }}>
                <RadioGroup
                  value={triviaAnswer}
                  onChange={(e) => setTriviaAnswer(e.target.value)}
                >
                  {triviaQuestion.options.map((option, index) => (
                    <FormControlLabel
                      key={index}
                      value={option}
                      control={<Radio />}
                      label={option}
                      sx={{ mb: 1 }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button 
                  variant="contained"
                  color="primary"
                  disabled={!triviaAnswer}
                  onClick={submitTriviaAnswer}
                >
                  Submit Answer
                </Button>
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTriviaDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Color Matcher Game Dialog */}
      <Dialog
        open={showColorGame}
        onClose={() => setShowColorGame(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Color Matcher</Typography>
            <IconButton onClick={() => setShowColorGame(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 3 }}>
            Adjust the RGB sliders to match the target color. Then click "Check Match" to see how close you got!
          </Typography>
          
          <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center', gap: 3 }}>
            <Box>
              <Typography variant="subtitle2" align="center" gutterBottom>
                Your Color
              </Typography>
              <Box 
                sx={{ 
                  width: 100, 
                  height: 100, 
                  bgcolor: colorCurrent,
                  borderRadius: 1,
                  boxShadow: 1,
                  mb: 1
                }} 
              />
            </Box>
            
            <Box>
              <Typography variant="subtitle2" align="center" gutterBottom>
                Target Color
              </Typography>
              <Box 
                sx={{ 
                  width: 100, 
                  height: 100, 
                  bgcolor: colorTarget,
                  borderRadius: 1,
                  boxShadow: 1,
                  mb: 1
                }} 
              />
            </Box>
          </Box>
          
          <Box sx={{ px: 2 }}>
            <Typography gutterBottom>Red: {colorValues.r}</Typography>
            <Slider
              value={colorValues.r}
              onChange={(e, newValue) => handleColorChange('r', newValue)}
              min={0}
              max={255}
              sx={{ 
                color: 'red',
                '& .MuiSlider-thumb': {
                  bgcolor: 'white',
                  border: '2px solid currentColor',
                }
              }}
            />
            
            <Typography gutterBottom>Green: {colorValues.g}</Typography>
            <Slider
              value={colorValues.g}
              onChange={(e, newValue) => handleColorChange('g', newValue)}
              min={0}
              max={255}
              sx={{ 
                color: 'green',
                '& .MuiSlider-thumb': {
                  bgcolor: 'white',
                  border: '2px solid currentColor',
                }
              }}
            />
            
            <Typography gutterBottom>Blue: {colorValues.b}</Typography>
            <Slider
              value={colorValues.b}
              onChange={(e, newValue) => handleColorChange('b', newValue)}
              min={0}
              max={255}
              sx={{ 
                color: 'blue',
                '& .MuiSlider-thumb': {
                  bgcolor: 'white',
                  border: '2px solid currentColor',
                }
              }}
            />
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={checkColorMatch}
            >
              Check Match
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => generateNewColorTarget()}>
            New Color
          </Button>
          <Button onClick={() => setShowColorGame(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MemberReset;
